import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import LegalLayout from 'components/ui/LegalLayout';
import { usePage } from 'shared/utils/pagesStorage';

/**
 * CustomPage — рендерит произвольную страницу из localStorage по slug.
 * Используется для созданных администратором FAQ/инфо-страниц.
 */
const CustomPage = () => {
    const { slug } = useParams();
    const page = usePage(slug);

    if (!page) {
        return <Navigate to="/404" replace />;
    }

    return (
        <LegalLayout title={page.title} lastUpdated={page.lastUpdated}>
            {/* eslint-disable-next-line react/no-danger */}
            <div
                className="prose prose-sm max-w-none text-text-primary"
                dangerouslySetInnerHTML={{ __html: page.bodyHtml || '' }}
            />
        </LegalLayout>
    );
};

export default CustomPage;
